import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { HelpContacts } from "widgets/help-contacts";

export const HelpPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div
        style={{
          fontFamily: 'font-family: "Syne", sans-serif',
          fontSize: 28,
          fontWeight: 800,
          letterSpacing: -0.5,
          color: "#FB0090",
          textAlign: "center",
          margin:
            "calc(82px + var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))) 0 28px 0",
        }}
      >
        AKJET
      </div>
      <Typography.Title level={3} style={{ textAlign: "center" }}>
        {t("support.something_went_wrong")}
      </Typography.Title>
      <Typography.Text
        style={{
          fontSize: 16,
          marginBottom: 48,
          display: "block",
          color: "var(--color-grey)",
          textAlign: "center",
        }}
      >
        {t("support.any_questions")}
      </Typography.Text>

      <HelpContacts />
    </div>
  );
};
